// extracted by mini-css-extract-plugin
module.exports = {"form-comment":"NewsComment_form-comment__3b1T1","input":"NewsComment_input__Tcsmj","submit":"NewsComment_submit__1NVaj"};